import dayjs from 'dayjs'
import { useMaintenanceGamesStore } from '~/stores/maintenance-games.store.ts'
import { DATE_TIME_FORMAT } from '~/constants'
import { useApi } from '~/composables/common/use-api'
import { MAINTENANCE_API } from '~/configs/api'

export function useMaintain() {
  const maintenanceStore = useMaintenanceGamesStore()
  const { request } = useApi()
  async function setMaintenanceGames(): Promise<void> {
    try {
      const { data } = await request(MAINTENANCE_API.USER_MAINTENANCE, {
        method: 'GET'
      })
      if (data?.length) {
        const startTime = dayjs(data[0].start_time).format(DATE_TIME_FORMAT.DATE_FORMAT_MAINTAIN)
        const endTime = dayjs(data[0].end_time).format(DATE_TIME_FORMAT.DATE_FORMAT_MAINTAIN)
        maintenanceStore.setMaintenanceGames(data[0].enable, startTime, endTime)
      }
    } catch {}
  }

  return {
    setMaintenanceGames
  }
}
